import { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import api from '../lib/api';

function AnuncioCard({ anuncio }) {
  const handleClick = async () => {
    try { await api.post(`/anuncios/${anuncio.id}/clique`); } catch {}
    if (anuncio.urlDestino && anuncio.urlDestino !== '#') {
      window.open(anuncio.urlDestino, '_blank', 'noopener');
    }
  };

  return (
    <div
      className="relative rounded-sm overflow-hidden cursor-pointer group"
      style={{ aspectRatio: '3/1' }}
      onClick={handleClick}
      data-testid="anuncio-card"
    >
      {anuncio.imagemUrl ? (
        <img
          src={anuncio.imagemUrl}
          alt={anuncio.titulo}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      ) : (
        <div className="w-full h-full bg-[#0F6E56] flex items-center justify-center">
          <span className="text-white/40 text-xs text-center px-2">{anuncio.titulo}</span>
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3 flex items-end gap-2">
        {anuncio.logoUrl ? (
          <img src={anuncio.logoUrl} alt="" className="w-7 h-7 rounded-lg object-cover flex-shrink-0 shadow" />
        ) : (
          <div className="w-7 h-7 bg-white/25 rounded-lg flex items-center justify-center flex-shrink-0 shadow backdrop-blur-sm">
            <span className="text-white font-bold text-xs">{anuncio.titulo?.[0]?.toUpperCase()}</span>
          </div>
        )}
        <p className="text-white text-xs font-semibold truncate drop-shadow">{anuncio.titulo}</p>
      </div>
      {anuncio.urlDestino && anuncio.urlDestino !== '#' && (
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="bg-black/30 rounded-lg p-1">
            <ExternalLink size={12} className="text-white" />
          </div>
        </div>
      )}
    </div>
  );
}

export function GradeAnuncios() {
  const [anuncios, setAnuncios] = useState([]);

  useEffect(() => {
    api.get('/anuncios?tipo=card').then(res => setAnuncios(res.data)).catch(() => {});
  }, []);

  // Always show 9 slots (filled or empty placeholders)
  const slots = [...anuncios, ...Array(Math.max(0, 9 - anuncios.length)).fill(null)];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="grade-anuncios">
      {slots.map((a, i) =>
        a ? (
          <AnuncioCard key={a.id} anuncio={a} />
        ) : (
          <div
            key={`empty-${i}`}
            className="rounded-sm bg-[#0F6E56]/40 border border-white/10 flex items-center justify-center cursor-pointer hover:bg-[#0F6E56]/60 transition-colors"
            style={{ aspectRatio: '3/1' }}
            data-testid="anuncio-slot-empty"
          >
            <div className="text-center text-white/30 text-xs px-2">
              <p className="font-medium">Anuncie aqui</p>
              <p>R$39/7 dias</p>
            </div>
          </div>
        )
      )}
    </div>
  );
}
